var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqRupees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 32.4C25.9529 32.4 32.4 25.9529 32.4 18C32.4 10.0471 25.9529 3.59998 18 3.59998C10.0471 3.59998 3.6 10.0471 3.6 18C3.6 25.9529 10.0471 32.4 18 32.4ZM12.6001 8.99998C11.6059 8.99998 10.8001 9.80586 10.8001 10.8C10.8001 11.7941 11.6059 12.6 12.6001 12.6H14.4001C15.7326 12.6 16.896 13.3239 17.5184 14.4H12.6001C11.6059 14.4 10.8001 15.2059 10.8001 16.2C10.8001 17.1941 11.6059 18 12.6001 18H17.5184C16.896 19.076 15.7326 19.8 14.4001 19.8H12.6001C11.872 19.8 11.2157 20.2385 10.9371 20.9111C10.6585 21.5838 10.8125 22.358 11.3273 22.8728L16.7273 28.2728C17.4302 28.9757 18.5699 28.9757 19.2728 28.2728C19.9758 27.5698 19.9758 26.4301 19.2728 25.7272L16.6025 23.0569C18.94 22.3066 20.757 20.3943 21.3732 18H23.4001C24.3942 18 25.2001 17.1941 25.2001 16.2C25.2001 15.2059 24.3942 14.4 23.4001 14.4H21.3732C21.2089 13.7614 20.9591 13.1571 20.6368 12.6H23.4001C24.3942 12.6 25.2001 11.7941 25.2001 10.8C25.2001 9.80586 24.3942 8.99998 23.4001 8.99998H12.6001Z",
    fill: "#6D57DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqRupees);
export default __webpack_public_path__ + "static/media/FaqRupees.be6968bd344ff8b43445ce136f6aadf2.svg";
export { ForwardRef as ReactComponent };